// import $ from 'jquery';
// import Plyr from 'plyr';
import 'protons';
import './_video.scss';
import './_video.twig';

export const name = 'video';

export const defaults = {};

export function disable() {}

// eslint-disable-next-line no-unused-vars
export function enable(context) {
  // $('.video', context).each((index, element) => {
  //   const $player = $('.video__player', element);
  //   const $text = $('.video__text', element);
  //
  //   const plyr = new Plyr($player.get(0), {
  //     controls: [
  //       'play',
  //       'play-large',
  //       'progress',
  //       'current-time',
  //       'mute',
  //       'volume',
  //       'settings',
  //       'fullscreen',
  //     ],
  //   });
  //
  //   if ($text.length) {
  //     // Start the video when the text is clicked.
  //     $text.on('click', () => plyr.play());
  //     // Toggle the text when the video starts playing or is paused.
  //     plyr.on('play pause', (event) => $text.toggle(event.type === 'pause'));
  //   }
  // });
}

export default enable;
